<template>
    <div
        class="stat-card"
        :class="{ active: activeFilter.key === filter.key }"
        @click="toggleStatFilter(filter)"
    >
        <span class="stat-card__label mr-2">{{ filter.name }}</span>

        <span class="stat-card__number">{{ stats[filter.key] }}</span>
    </div>
</template>

<script>
export default {
    props: ['filter', 'activeFilter', 'stats'],
    methods: {
        toggleStatFilter(filter) {
            this.$emit('toggleStatFilter', filter);
        }
    }
}
</script>

<style lang="scss" scoped>
.stat-card {
    position: relative;
    display: flex;
    align-items: center;
    padding: 16px 30px;
    background: rgba(255, 255, 255, 0.1);
    border: 2px solid transparent;
    border-radius: $border-radius;
    color: $color-white;
    line-height: 1;
    transition: all 0.3 ease;
    cursor: pointer;
    z-index: 1;

    .stat-card__number {
        background: rgba(255, 255, 255, 0.1);
        border-radius: 12px;
        padding: 2px 6px;
        font-size: rem(14px);
        font-weight: 600;
    }

    .stat-card__label {
        font-size: rem(16px);
    }

    &:hover {
        background: rgba(255, 255, 255, 0.05);
    }

    &.active {
        background: transparent;
        border-color: $color-secondary;
        color: $color-secondary;

        .stat-card__number {
            background: $color-gold;
            color: $color-white;
        }
    }
}
</style>
